export default "__VITE_ASSET__CNm_0ox5__"